export abstract class RouteConstants {
  private static readonly _LOGIN_MODULE = '/login';
  private static readonly _ADMIN_MODULE = '/admin';
  private static readonly _COMPANY_MODULE = '/company';
  private static readonly _PRODUCT_MODULE = '/product';
  private static readonly _HELP_MODULE = '/help';

  public static readonly HELP_MODULE = {
    BASE: RouteConstants._HELP_MODULE,
    VIDEOS: RouteConstants._HELP_MODULE + '/videos',
    DOCUMENTS: RouteConstants._HELP_MODULE + '/documents',
    FAQS: RouteConstants._HELP_MODULE + '/faqs',
  }
  public static readonly ADMIN_MODULE = {
    COMPANY_MANAGER: RouteConstants._ADMIN_MODULE + '/company-manager',
    SETTINGS: RouteConstants._ADMIN_MODULE + '/settings'
  };

  public static readonly COMPANY_MODULE = {
    BASE: RouteConstants._COMPANY_MODULE,
    SETTINGS: RouteConstants._COMPANY_MODULE + '/settings'
  };

  public static readonly PRODUCT_MODULE = {
    CATALOG: RouteConstants._PRODUCT_MODULE + '/catalog',
    DASHBOARD: RouteConstants._PRODUCT_MODULE + '/dashboard',
    DOWNLOADS: RouteConstants._PRODUCT_MODULE + '/downloads',
    PRODUCT_DETAIL: RouteConstants._PRODUCT_MODULE + '/detail',
  };

  public static readonly LOGIN_MODULE = {
    LOGIN: RouteConstants._LOGIN_MODULE
  };
}
